// extracted by mini-css-extract-plugin
export var Img = "v_L";
export var aniSpin = "v_d";
export var img = "v_N";
export var isFull = "v_M";
export var placeholder = "v_P";